<template>
  <div class="g-pagination g-clearfix" v-if="total > 0">
    <a-pagination
      v-bind="$attrs"
      v-on="$listeners"
      :total="total"
      :pageSize="pageSize"
      :showSizeChanger="showSizeChanger"
      :pageSizeOptions="pageSizeOptions"
      @showSizeChange="showSizeChange"
    >
    </a-pagination>

    <div class="g-pagination-text" v-if="showTotal">
      {{ $t('com_pagination_total') }}:<span>{{ total }}</span>
    </div>
    <div style="height: 0px; clear: both; overflow: hidden"></div>
  </div>
</template>

<script>
/**
 * 参数
 * curpage  Number   当前页
 * pageSize  Number   每页的数据量大小
 * totalCount  Number   数据总量
 *
 * 事件
 * update:pageSize   每页数据量改变
 * update:pageNo   当前页改变
 */

export default {
  props: {
    // 总条数
    total: {
      type: Number,
      default: 0,
    },
    // 总页数
    totalPage: {
      type: Number,
      default: 1,
    },
    // 是否显示总条数
    showTotal: {
      type: Boolean,
      default: true,
    },

    // 是否显示分页数量
    showSizeChanger: {
      type: Boolean,
      default: true,
    },

    // 每页显示
    pageSize: {
      type: Number,
      default: 20,
    },

    callback: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
    };
  },
  methods: {
    // showPageSize的回调回调
    showSizeChange(current, pageSize) {
      this.$emit('update:pageSize', Number(pageSize));
      this.callback(current);
    },
  },
};
</script>

<style lang="less" scoped>
.g-pagination {
  position: relative;
  padding: 15px 0;

  .g-pagination-text {
    display: block;
    height: 32px;
    line-height: 32px;
    float: right;
    font-size: 14px;

    span {
      padding-right: 10px;
    }
  }

  ::v-deep .ant-pagination {
    float: right;
    margin-left: 0;
    .ant-pagination-options-size-changer.ant-select {
      margin-right: 0 !important;
    }
  }

  ::v-deep .ant-pagination-options {
    margin-left: 5px;
  }
}
@media (max-width: 480px) {
  .g-pagination {
    position: relative;
    margin-top: 5px !important;

    .g-pagination-text {
      display: block;
      height: 24px;
      line-height: 24px;
      float: none;
      span {
        padding: 0 0 0 5px !important;
      }
    }

    ::v-deep .ant-pagination {
      float: left;
      width: 100%;
    }
  }
}
</style>
